import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { DriversContent } from "@/features/dashboard/motoristas/components/DriversContent";

export const Route = createFileRoute("/_private/dashboard/_base/motoristas/editar/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Editar Motorista</DashboardComponents.Title>

      <DriversContent />
    </Stack>
  );
}
